<template>
  <div class="navbar">
    <logo v-if="showLogo" :collapse="isCollapse" />
    <hamburger
      :is-active="sidebar.opened"
      class="hamburger-container"
      :class="{'hamburger-close-slide': isCollapse }"
      @toggleClick="toggleSideBar"
    />

    <div class="right-menu" style="display: flex;align-items: center;">
      <time-zone-select v-if="$store.getters.isPii" style="height: 60px;line-height: 60px" class="right-menu-item hover-effect lang-select" />
      <div v-if="$store.getters.isPii" class="line-flex" />
      <DownLoadManage />
      <div class="line-flex" />
      <country-select v-if="$store.getters.isPii" class="right-menu-item hover-effect lang-select" />
      <div v-if="$store.getters.isPii" class="line-flex" />
      <lang-select class="right-menu-item hover-effect lang-select" />
      <div class="line-flex" />
      <message-manage v-if="$store.getters.isPii" class="right-menu-item hover-effect lang-select" />
      <div v-if="$store.getters.isPii" class="line-flex" />
      <div class="username">
        <span
          v-if="kycStatusCode && !$store.getters.isMX"
          class="kyc-status"
          :class="[getKycStatusClass, { 'kyc-clickable': isKycClickable }]"
          @click="handleKycClick"
        >{{ getKycStatusLabel }}</span>
        <el-tooltip
          :disabled="name.length < 25"
          placement="top"
          effect="light"
        >
          <div slot="content">{{ name }}</div>
          <span v-if="name.length >= 25" class="name-content"><strong>{{ name }}</strong></span>
          <span v-else><strong>{{ name }}</strong></span>
        </el-tooltip>
      </div>

      <el-dropdown class="avatar-container right-menu-item hover-effect" trigger="click">
        <div class="avatar-wrapper">
          <img src="@/assets/head_images/head_image.png" class="user-avatar">
          <i class="el-icon-arrow-down icon-arrow-down" />
        </div>
        <el-dropdown-menu slot="dropdown" class="user-dropdown">
          <router-link to="/">
            <el-dropdown-item>
              {{ $t('components.home') }}
            </el-dropdown-item>
          </router-link>
          <el-dropdown-item divided @click.native="gotoAccountSetting">
            <span style="display:block;">{{ $t('menu.account_settings') }}</span>
          </el-dropdown-item>
          <el-dropdown-item divided @click.native="logout">
            <span style="display:block;"> {{ $t('components.login_out') }}</span>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { kycStatusMap } from '@/utils/maps'
import Hamburger from '@/components/Hamburger'
import LangSelect from './components/LangSelect'
import CountrySelect from './components/CountrySelect'
import DownLoadManage from './components/DownLoadManage'
import TimeZoneSelect from './components/TimeZoneSelect'
import MessageManage from './components/MessageManage/index.vue'

import Logo from './Sidebar/Logo'

export default {
  components: {
    Hamburger,
    LangSelect,
    Logo,
    CountrySelect,
    DownLoadManage,
    TimeZoneSelect,
    MessageManage
  },
  computed: {
    ...mapGetters([
      'sidebar',
      'avatar',
      'name',
      'mainUserName'
    ]),
    kycStatusCode() {
      const merchantInfo = this.$store.getters.userInfo && this.$store.getters.userInfo.merchant_info
      return merchantInfo && merchantInfo.kyc_status ? merchantInfo.kyc_status : null
    },
    getKycStatusLabel() {
      const entry = kycStatusMap(this.kycStatusCode)
      return entry && entry.label ? entry.label : ''
    },
    getKycStatusClass() {
      const entry = kycStatusMap(this.kycStatusCode)
      return entry && entry.className ? entry.className : ''
    },
    showLogo() {
      return this.$store.state.settings.sidebarLogo
    },
    isCollapse() {
      return !this.sidebar.opened
    },
    isKycClickable() {
      // allow navigation when KYC is unverified (1) or rejected (4)
      return this.kycStatusCode === 1 || this.kycStatusCode === 4
    }
  },
  methods: {
    toggleSideBar() {
      this.$store.dispatch('app/toggleSideBar')
    },
    async logout() {
      // 重置弹窗状态，确保重新登录后可以正常弹窗
      window._pendingPopupShown = false
      await this.$store.dispatch('user/logout')
      this.$router.push(`/login?redirect=${this.$route.fullPath}`)
    },
    gotoAccountSetting() {
      this.$router.push('/systemManage/settings')
    },
    handleKycClick() {
      if (this.isKycClickable) {
        this.$router.push('/kyc')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.line-flex{
  display: inline-block;
  position: relative;
  margin: 0 24px;
  width: 1px;
  height: 26px;
  background: #B5BCC9;
}
.icon-arrow-down{
  position: relative;
  top: -10px;
  margin-left: 12px;
  font-size: 12px;
  font-weight: bold;
}
.navbar {
  padding-right: 28px;
  height: 56px;
  overflow: hidden;
  position: relative;
  background: #fff;
  box-shadow: 0 1px 4px rgba(0,21,41,.08);

  .hamburger-container {

    line-height: 60px;
    height: 100%;
    /*float: left;*/
    display: inline-block;
    vertical-align: top;
    cursor: pointer;
    transition: background .3s;
    -webkit-tap-highlight-color:transparent;

    &:hover {
      background: rgba(0, 0, 0, .025)
    }
  }
  .hamburger-close-slide{
    margin-left: 41px;
  }
  .left-menu{
    display: inline-block;
    vertical-align: top;
    line-height: 60px;
    font-size: 14px;
    >span:nth-child(2){
      color: #3579FF;
      text-decoration: underline;
    }

  }
  .right-menu {
    float: right;
    height: 100%;
    display: flex;
    align-items: center;
    line-height: 50px;

    &:focus {
      outline: none;
    }

    .right-menu-item {
      display: inline-block;
      padding-left: 8px;
      height: 100%;
      font-size: 18px;
      color: #5a5e66;
      vertical-align: text-bottom;

      &.lang-select{
        padding-top: 3px;
      }

      &.hover-effect {
        cursor: pointer;
        transition: background .3s;

        &:hover {
          background: rgba(0, 0, 0, .025)
        }
      }
    }
    .avatar-wrapper {
      // box-sizing: border-box;
      height: 60px;
      .user-avatar {
        width: 32px;
        margin-top: 14px;
      }
      .el-icon-caret-bottom{
        position: relative;
        top: -7px;
        left: 4px;
      }
    }
    .kyc-status{
      display:inline-block;
      margin-right:8px;
      padding:4px 8px;
      border-radius:12px;
      font-size:12px;
      color:#1F2937;
      background:#F1F5F9;
      vertical-align: middle;
    }
    .kyc-clickable{ cursor: pointer; }
    .kyc-1{ background:#FEF3F2; color:#B91C1C; } /* Unverified - red tint */
    .kyc-2{ background:#FFFBEB; color:#92400E; } /* Pending - amber */
    .kyc-3{ background:#ECFDF5; color:#047857; } /* Verified - green tint */
    .kyc-4{ background:#FFF7ED; color:#92400E; } /* Rejected - orange tint */
    .username{
      display: flex;
      align-items: center;
      margin: 0 20px 0 16px;
      vertical-align: text-bottom;
      font-size: 14px;
      font-weight: 500;  font-family: 'Inter-Medium';
      color: #1D3A71;
      min-width: 40px;
    }
    .name-content {
      display: inline-block;
      max-width: 180px;
      vertical-align: middle;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
}
@media screen and (max-width: 376px) {
  .navbar {
     .right-menu {
      //  width: 130px;
       .username{
         margin: 0;
         margin-left: 5px;
       }
      }

  }
}
@media screen and (max-width: 761px) {
 .line{
  display: none;
 }
}
</style>
